
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("iaTgw"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("iaTgw", function(module, exports) {

let $d3b407bb7c066235$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d3b407bb7c066235$var$load("h3ABO"),
    $d3b407bb7c066235$var$load("djHM5"),
    $d3b407bb7c066235$var$load("eJQji"),
    $d3b407bb7c066235$var$load("2YffH"),
    $d3b407bb7c066235$var$load("6mHrv"),
    $d3b407bb7c066235$var$load("awWN9"),
    $d3b407bb7c066235$var$load("9CYct"),
    $d3b407bb7c066235$var$load("bRKjd"),
    $d3b407bb7c066235$var$load("ap5Gz"),
    $d3b407bb7c066235$var$load("hZtKG"),
    $d3b407bb7c066235$var$load("iNmaF"),
    $d3b407bb7c066235$var$load("lVO3w"),
    $d3b407bb7c066235$var$load("hyzoX"),
    $d3b407bb7c066235$var$load("h9Ed7"),
    $d3b407bb7c066235$var$load("eBRUf"),
    $d3b407bb7c066235$var$load("kbRvk"),
    $d3b407bb7c066235$var$load("tKhaz"),
    $d3b407bb7c066235$var$load("5eNHu"),
    $d3b407bb7c066235$var$load("6iBAZ"),
    $d3b407bb7c066235$var$load("cD6Zr"),
    $d3b407bb7c066235$var$load("fPSgL"),
    $d3b407bb7c066235$var$load("aDOZ4"),
    $d3b407bb7c066235$var$load("9wzNh"),
    $d3b407bb7c066235$var$load("8YSo7"),
    $d3b407bb7c066235$var$load("3Zfzp"),
    $d3b407bb7c066235$var$load("Wowvf"),
    $d3b407bb7c066235$var$load("9ldRJ"),
    $d3b407bb7c066235$var$load("9anPW"),
    $d3b407bb7c066235$var$load("50ame"),
    $d3b407bb7c066235$var$load("e7ZUf"),
    $d3b407bb7c066235$var$load("gL8bn"),
    $d3b407bb7c066235$var$load("ebWFc"),
    $d3b407bb7c066235$var$load("g9CVe"),
    $d3b407bb7c066235$var$load("7oiUM"),
    $d3b407bb7c066235$var$load("8t3po"),
    $d3b407bb7c066235$var$load("855o0"),
    $d3b407bb7c066235$var$load("8MfZE"),
    $d3b407bb7c066235$var$load("hv4mn"),
    $d3b407bb7c066235$var$load("dek7I"),
    $d3b407bb7c066235$var$load("dYtBN"),
    $d3b407bb7c066235$var$load("6wr18"),
    $d3b407bb7c066235$var$load("kjZZD"),
    $d3b407bb7c066235$var$load("2zxmz"),
    $d3b407bb7c066235$var$load("7269o"),
    $d3b407bb7c066235$var$load("gizWr"),
    $d3b407bb7c066235$var$load("4PUiY"),
    $d3b407bb7c066235$var$load("37ldp"),
    $d3b407bb7c066235$var$load("ffEVr"),
    $d3b407bb7c066235$var$load("dRpV3"),
    $d3b407bb7c066235$var$load("dTsOE"),
    $d3b407bb7c066235$var$load("hhss7"),
    $d3b407bb7c066235$var$load("jwTn5"),
    $d3b407bb7c066235$var$load("aYdgM"),
    $d3b407bb7c066235$var$load("jY21r"),
    $d3b407bb7c066235$var$load("8fMw3"),
    $d3b407bb7c066235$var$load("hogcU"),
    $d3b407bb7c066235$var$load("8Vzcw"),
    $d3b407bb7c066235$var$load("co52j"),
    $d3b407bb7c066235$var$load("7EorR"),
    $d3b407bb7c066235$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.305a5fd0.js.map
